module.exports = __webpack_public_path__ + "img/85.d54c8861.jpg";